import script from "./AfterSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./AfterSignup.vue?vue&type=script&setup=true&lang=js"

import "./AfterSignup.vue?vue&type=style&index=0&id=4aba6bee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4aba6bee"]])

export default __exports__